module.exports = __webpack_public_path__ + "static/media/example-meglive-flash.e28431f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/example-meglive-flash.png
// module id = 762
// module chunks = 0